export default "__VITE_ASSET__CsB5KDST__"